import React from 'react';
import { Route, Switch } from "react-router-dom";
import Loadable from 'react-loadable';
import { Spin } from 'antd'

function MyLoadingComponent() {
    return <Spin size="large"><div style={{ width: '100%', height: '100%' }}></div></Spin>;
}
const device = Loadable({ loader: () => import('./content/device.js'), loading: MyLoadingComponent });
const NotFoundPage = Loadable({ loader: () => import('./nofind/nofind.js'), loading: MyLoadingComponent });
const devFault = Loadable({ loader: () => import('./devFault/devfault.js'), loading: MyLoadingComponent });
const storeManage = Loadable({ loader: () => import('./storemanage/storemanage.js'), loading: MyLoadingComponent });

/**
 * @description: 运营中心》设备管理》设备详情
 * @author: 宁振益
 * @date: 2019-07-24 12:55:30
 * @variable1: devInfo
 */
const devInfo = Loadable({
    loader: () => import('./content/devInfo.js'),
    loading: MyLoadingComponent,
    render(loaded, props) {
        let Component = loaded.default;
        let myProps = Object.assign({}, props);
        myProps['pageType'] = 'deviceInfo';
        return <Component {...myProps} />;
    }
});

/**
 * @description: 生产中心》设备库存》设备详情
 * @author: 宁振益
 * @date: 2019-07-24 12:54:38
 * @variable1: StockDevice
 */
const StockDevice = Loadable({
    loader: () => import('./content/devInfo.js'),
    loading: MyLoadingComponent,
    render(loaded, props) {
        let Component = loaded.default;
        let myProps = Object.assign({}, props);
        myProps['pageType'] = 'stockDevice';
        return <Component {...myProps} />;
    }
});

/**
 * @description: 运维中心》运维设备》设备详情
 * @author: 宁振益
 * @date: 2019-07-24 12:54:08
 * @variable1: RepairDeviceDetail
 */
const RepairDeviceDetail = Loadable({
    loader: () => import('./content/devInfo.js'),
    loading: MyLoadingComponent,
    render(loaded, props) {
        let Component = loaded.default;
        let myProps = Object.assign({}, props);
        myProps['pageType'] = 'repairDevice';
        return <Component {...myProps} />;
    }
});

/**
 * @description: 生产中心》设备管理》设备详情
 * @author: 宁振益
 * @date: 2019-07-24 12:53:32
 * @variable1: DeviceManageDetail 
 */
const DeviceManageDetail = Loadable({
    loader: () => import('./content/devInfo.js'),
    loading: MyLoadingComponent,
    render(loaded, props) {
        let Component = loaded.default;
        let myProps = Object.assign({}, props);
        myProps['pageType'] = 'deviceManage';
        return <Component {...myProps} />;
    }
});

const goodManage = Loadable({ loader: () => import('./goodManage/goodManage.js'), loading: MyLoadingComponent });
const shelfInfo = Loadable({ loader: () => import('./shelfManage/shelfInfo.js'), loading: MyLoadingComponent });
const orderInfo = Loadable({ loader: () => import('./orderManage/orderInfo.js'), loading: MyLoadingComponent });
const alarmManage = Loadable({ loader: () => import('./operation/alarmManage.js'), loading: MyLoadingComponent });
const history = Loadable({ loader: () => import('./operation/history.js'), loading: MyLoadingComponent });
const refundManage = Loadable({ loader: () => import('./orderManage/refundManage.js'), loading: MyLoadingComponent });
const goodsSpec = Loadable({ loader: () => import('./goodManage/goodsSpec.js'), loading: MyLoadingComponent });
const priceMange = Loadable({ loader: () => import('./goodManage/priceMange.js'), loading: MyLoadingComponent });
const storeRecharge = Loadable({ loader: () => import('./storemanage/storeRecharge.js'), loading: MyLoadingComponent });
const capitalCount = Loadable({ loader: () => import('./capital/capitalCount.js'), loading: MyLoadingComponent });
const material = Loadable({ loader: () => import('./goodManage/material.js'), loading: MyLoadingComponent });
const messageConfig = Loadable({ loader: () => import('./message/messageconfig.js'), loading: MyLoadingComponent });
const addMsgConfig = Loadable({ loader: () => import('./message/addmsgconfig.js'), loading: MyLoadingComponent });
const messageInfo = Loadable({ loader: () => import('./message/messageInfo.js'), loading: MyLoadingComponent });
const couponCount = Loadable({ loader: () => import('./capital/couponCount.js'), loading: MyLoadingComponent });
const orderInfoHistory = Loadable({ loader: () => import('./orderManage/orderHistory.js'), loading: MyLoadingComponent });
const addMaterial = Loadable({ loader: () => import('./goodManage/addMaterial.js'), loading: MyLoadingComponent });
const updateMaterial = Loadable({ loader: () => import('./goodManage/updateMaterial.js'), loading: MyLoadingComponent });
const materialUnit = Loadable({ loader: () => import('./goodManage/materialUnit.js'), loading: MyLoadingComponent });
const addSpec = Loadable({ loader: () => import('./goodManage/addSpec.js'), loading: MyLoadingComponent });
const updateSpec = Loadable({ loader: () => import('./goodManage/updateSpec.js'), loading: MyLoadingComponent });
const addstore = Loadable({ loader: () => import('./storemanage/addstore.js'), loading: MyLoadingComponent });
const updatestore = Loadable({ loader: () => import('./storemanage/updatestore.js'), loading: MyLoadingComponent });
const purchaseOrder = Loadable({ loader: () => import('./purchaseOrder/purchaseOrder.js'), loading: MyLoadingComponent });
const addpcorder = Loadable({ loader: () => import('./purchaseOrder/addPcOrder.js'), loading: MyLoadingComponent });
const pcorderdetail = Loadable({ loader: () => import('./purchaseOrder/pcOrderDetail.js'), loading: MyLoadingComponent });
const specDetail = Loadable({ loader: () => import('./goodManage/specDetail.js'), loading: MyLoadingComponent });
const storeDetail = Loadable({ loader: () => import('./storemanage/storeDetail.js'), loading: MyLoadingComponent });
const deviceFault = Loadable({ loader: () => import('./devFault/deviceFault.js'), loading: MyLoadingComponent });
const deviceStatistics = Loadable({ loader: () => import('./content/deviceStatistics.js'), loading: MyLoadingComponent });
const analysis = Loadable({ loader: () => import('./home/Analysis.js'), loading: MyLoadingComponent });
const sendMessage = Loadable({ loader: () => import('./message/sendMessage.js'), loading: MyLoadingComponent });
const messageDetails = Loadable({ loader: () => import('./message/messageDetails.js'), loading: MyLoadingComponent });
const messageType = Loadable({ loader: () => import('./message/messageType.js'), loading: MyLoadingComponent });
const sendRecord = Loadable({ loader: () => import('./message/sendRecord.js'), loading: MyLoadingComponent });
const deviceRepairQuery = Loadable({ loader: () => import('./afterService/deviceRepairQuery'), loading: MyLoadingComponent });
const deviceRepairMange = Loadable({ loader: () => import('./afterService/deviceRepairMange'), loading: MyLoadingComponent });
const deviceMonitor = Loadable({ loader: () => import('./afterService/deviceMonitor'), loading: MyLoadingComponent });
const deviceModelput = Loadable({ loader: () => import('./sale/deviceModelput.js'), loading: MyLoadingComponent });
const userOrderManage = Loadable({ loader: () => import('./sale/OrderManage.js'), loading: MyLoadingComponent });
const customerOrderManage = Loadable({ loader: () => import('./sale/customerOrderManage.js'), loading: MyLoadingComponent });
const ProductManage = Loadable({ loader: () => import('./sale/ProductManage.js'), loading: MyLoadingComponent });
const DeliveryManage = Loadable({ loader: () => import('./sale/DeliveryManage.js'), loading: MyLoadingComponent });
const saleManage = Loadable({ loader: () => import('./sale/saleManage.js'), loading: MyLoadingComponent });
// const saleOrderDetail = Loadable({ loader: () => import('./sale/orderDetail.js'), loading: MyLoadingComponent });
const CustomerManage = Loadable({ loader: () => import('./devopscenter/CustomerManage.js'), loading: MyLoadingComponent });
const OperatorManage = Loadable({ loader: () => import('./devopscenter/OperatorManage.js'), loading: MyLoadingComponent });
const DeviceOpsConfig = Loadable({ loader: () => import('./devopscenter/DeviceOpsConfig.js'), loading: MyLoadingComponent });
const EnterpriseInfo = Loadable({ loader: () => import('./enterprisecenter/EnterpriseInfo.js'), loading: MyLoadingComponent });
const DeviceManage = Loadable({ loader: () => import('./device/Manage.js'), loading: MyLoadingComponent });
const DeviceStock = Loadable({ loader: () => import('./device/Stock.js'), loading: MyLoadingComponent });
const RepairDevice = Loadable({ loader: () => import('./devopscenter/RepairDevice.js'), loading: MyLoadingComponent });

// 平台服务相关
const EntDevList = Loadable({ loader: () => import('./cost/EntDevList.js'), loading: MyLoadingComponent });//企业设备列表
const PlatServOrder = Loadable({ loader: () => import('./cost/CostServOrder.js'), loading: MyLoadingComponent });//平台服务订单
const ServOrderBill = Loadable({ loader: () => import('./cost/CostOrderBill.js'), loading: MyLoadingComponent });//平台服务账单
const ServiceAgreement = Loadable({ loader: () => import('./nofind/developing'), loading: MyLoadingComponent });//服务协议
const CostInvoice = Loadable({ loader: () => import('./cost/costInvoice.js'), loading: MyLoadingComponent });//发票管理
const CostDevice = Loadable({ loader: () => import('./cost/CostDev.js'), loading: MyLoadingComponent });//设备列表
const CostDevOrder = Loadable({ loader: () => import('./cost/CostDevOrder.js'), loading: MyLoadingComponent });//签约列表
const CostOrderInfo =  Loadable({ loader: () => import('./cost/costOrderInfo.js'), loading: MyLoadingComponent });//账单管理

const MyRoute = () => {
    return (
        <Switch>
            <Route path="/dashboard" component={analysis} />
            {/* 设备相关 */}
            <Route exact path="/device" component={device} />
            <Route path="/device/detail" component={devInfo} />
            <Route path="/device/statistics" component={deviceStatistics} />
            <Route path="/device/history" component={history} />
            <Route exact path="/device/manage" component={DeviceManage} />
            <Route path="/device/manage/detail" component={DeviceManageDetail} />
            <Route exact path="/device/stock" component={DeviceStock} />
            <Route path="/device/stock/detail" component={StockDevice} />
            {/* #################### */}


            {/* 运维相关 */}
            <Route exact path="/devops/fault" component={deviceFault} />
            <Route exact path="/devops/fault/history" component={devFault} />
            <Route exact path="/devops/alarm" component={alarmManage} />
            {/* #################### */}


            {/* 门店相关 */}
            <Route exact path="/store" component={storeManage} />
            <Route path="/store/add" component={addstore} />
            <Route path="/store/update" component={updatestore} />
            <Route path="/store/detail" component={storeDetail} />
            <Route path="/store/recharge" component={storeRecharge} />
            {/* #################### */}


            {/* 商品相关 */}
            <Route exact path="/goods" component={goodManage} />
            <Route exact path="/goods/spec" component={goodsSpec} />
            <Route path="/goods/spec/detail" component={specDetail} />
            <Route path="/goods/spec/add" component={addSpec} />
            <Route path="/goods/spec/update" component={updateSpec} />
            <Route path="/goods/shelf" component={shelfInfo} />
            <Route path="/goods/price" component={priceMange} />
            {/* #################### */}

            {/* 库存相关 */}
            <Route exact path="/stock/material" component={material} />
            <Route path="/stock/material/unit" component={materialUnit} />
            <Route path="/stock/material/add" component={addMaterial} />
            <Route path="/stock/material/update" component={updateMaterial} />
            <Route exact path="/stock/order" component={purchaseOrder} />
            <Route path="/stock/order/pcorder" component={addpcorder} />
            <Route path="/stock/order/detail" component={pcorderdetail} />
            {/* #################### */}

            {/* 订单相关 */}
            <Route path="/order/notcompleted" component={orderInfo} />
            <Route path="/order/completed" component={orderInfoHistory} />
            <Route path="/order/refund" component={refundManage} />
            {/* #################### */}


            {/* 资金相关 */}
            <Route path="/capital/statistics/money" component={capitalCount} />
            <Route path="/capital/statistics/coupon" component={couponCount} />
            {/* #################### */}

            {/* 消息相关 */}
            <Route path="/message/manage" component={sendRecord} />
            <Route exact path="/message/config" component={messageConfig} />
            <Route path="/message/config/add" component={addMsgConfig} />
            <Route path="/message/config/history" component={messageInfo} />
            <Route path="/message/send" component={sendMessage} />
            <Route path="/message/detail" component={messageDetails} />
            <Route path="/message/type" component={messageType} />
            {/* #################### */}

            {/* 售后服务相关 */}
            <Route path="/aftersale/repair/query" component={deviceRepairQuery} />
            <Route path="/aftersale/repair/mange" component={deviceRepairMange} />
            <Route path="/aftersale/device/monitor" component={deviceMonitor} />
            <Route exact path="/aftersale/repair/devices" component={RepairDevice} />
            <Route path="/aftersale/repair/devices/detail" component={RepairDeviceDetail} />
            {/* #################### */}

            {/* 设备销售相关 */}
            <Route path="/operator/purchase/devBuy" component={saleManage} />
            <Route path="/operator/purchase/devOrder" component={customerOrderManage} />

            <Route path="/product/sale/devPutaway" component={deviceModelput} />
            <Route path="/product/sale/orderManage" component={userOrderManage} />
            <Route path="/product/product/productManage" component={ProductManage} />
            <Route path="/product/product/deliveryManage" component={DeliveryManage} />
            {/* #################### */}

            {/* 客户相关 */}
            <Route path="/customer/manage" component={CustomerManage}></Route>
            {/* #################### */}

            {/* 运维商相关 */}
            <Route path="/ops/merchant" component={OperatorManage}></Route>
            <Route path="/device/config" component={DeviceOpsConfig}></Route>
            {/* #################### */}

            {/* 企业中心  */}
            <Route path="/enterprise/info" component={EnterpriseInfo}></Route>
            <Route path="/enterprise/entDevList" component={EntDevList}></Route>
            <Route path="/enterprise/platServOrder" component={PlatServOrder}></Route>
            <Route path="/enterprise/servOrderBill" component={ServOrderBill}></Route>
            
            <Route path="/enterprise/serviceagreement" component={ServiceAgreement}></Route>
            <Route path='/enterprise/costInvoice' component={CostInvoice}></Route>
            <Route path='/enterprise/costOrderInfo' component ={CostOrderInfo}></Route>
            <Route path='/enterprise/costdevice' component={CostDevice}></Route>
            <Route path='/enterprise/costdevorder' component={CostDevOrder}></Route>
            {/* #################### */}

            <Route path='/404' component={NotFoundPage} />
        </Switch>
    )
}

export default MyRoute;